import { ThemeProvider } from "@mui/material";
import "./App.css";
import "./assets/styles/fonts.css";
import RouteConfig from "./routes/RouteConfig";
import { globalStyles, theme } from "./theme";
import ToastProvider from "./components/common/ToastProvider";
import { GlobalDataProvider } from "./contexts/GlobalDataContext";
import { setGlobalNavigate } from "./utils/helpers";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getServerTime } from "./features/auth/authSlice";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);
  const path = location.pathname;


  const dispatch = useDispatch();



   useEffect(() => {
    getTime();
  }, [path]);

const getTime = async () =>{
  try {
    const {payload } = await dispatch(getServerTime())
    console.log('Server Time (UTC):', payload.time);
    localStorage.setItem('serverTime', payload.time);
  } catch (error) {
    console.error('Error fetching server time:', error);
  }
}

  // console.log(navigator.onLine , "navigator")
  return (
    <GlobalDataProvider>
      <ToastProvider>
        <ThemeProvider theme={theme}>
          {globalStyles}
          <RouteConfig />
        </ThemeProvider>
      </ToastProvider>
    </GlobalDataProvider>
  );
}

export default App;
